



























































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component
export default class TextField extends Vue {
  @Model('change', { type: String }) value!: string;
  @Prop({ type: [String, Object], required: true }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: String, default: 'text' }) type!: string;
  @Prop({ type: Boolean, default: false }) disabled!: string;
  @Prop({ type: Boolean, default: false }) readonly!: string;
  @Prop({ type: Boolean, default: false }) showChangeButton!: string;
}
